// Core
import { combineReducers } from 'redux';

// Reducers
import app from './app/reducer';
import auth from './auth/reducer';
import session from './session/reducer';

// Combined reducers
const rootReducer = combineReducers({
  app,
  auth,
  session,
});

export default rootReducer;
